const shouldDisplayL = window.innerWidth > 1280;
const shouldDisplayXL = window.innerWidth > 1798;
const shouldShowMobileNavbar = window.innerWidth < 992;

export { shouldDisplayL, shouldDisplayXL, shouldShowMobileNavbar };
